import TrailSummary from './TrailSummary';

export default TrailSummary;
